var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFlowTypeRag(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-genai",
    clipPath: "url(#clip0_24149_107748)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.7226 4.05355C10.7756 3.91557 10.9063 3.82483 11.0517 3.82483C11.1971 3.82483 11.3277 3.91557 11.3807 4.05355L12.6186 7.27091L15.7756 8.53243C15.911 8.58659 16.0001 8.71963 16.0001 8.86782C16.0001 9.01601 15.911 9.14913 15.7756 9.20321L12.6186 10.4647L11.3807 13.6821C11.3277 13.8201 11.1971 13.9108 11.0517 13.9108C10.9063 13.9108 10.7756 13.8201 10.7226 13.6821L9.48474 10.4647L6.32775 9.20321C6.19232 9.14913 6.10327 9.01601 6.10327 8.86782C6.10327 8.71963 6.19232 8.58659 6.32775 8.53243L9.48474 7.27091L10.7226 4.05355Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.92715 0.180687C3.96904 0.0716624 4.07224 0 4.1871 0C4.30197 0 4.40517 0.0716624 4.44714 0.180687L5.42506 2.72247L7.91913 3.71908C8.02611 3.76185 8.09645 3.86695 8.09645 3.98406C8.09645 4.10109 8.02611 4.20627 7.91913 4.24897L5.42506 5.24565L4.44714 7.78736C4.40517 7.89639 4.30197 7.96813 4.1871 7.96813C4.07224 7.96813 3.96904 7.89639 3.92715 7.78736L2.94923 5.24565L0.455157 4.24897C0.348175 4.20627 0.277832 4.10109 0.277832 3.98406C0.277832 3.86695 0.348175 3.76185 0.455157 3.71908L2.94923 2.72247L3.92715 0.180687Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.69977 10.239C2.73076 10.1584 2.80706 10.1053 2.89209 10.1053C2.97704 10.1053 3.05341 10.1584 3.08441 10.239L3.80786 12.1194L5.653 12.8567C5.73207 12.8883 5.78417 12.9661 5.78417 13.0527C5.78417 13.1394 5.73207 13.2171 5.653 13.2487L3.80786 13.986L3.08441 15.8664C3.05341 15.947 2.97704 16 2.89209 16C2.80706 16 2.73076 15.947 2.69977 15.8664L1.97632 13.986L0.131177 13.2487C0.0520998 13.2171 0 13.1394 0 13.0527C0 12.9661 0.0520998 12.8883 0.131177 12.8567L1.97632 12.1194L2.69977 10.239Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_24149_107748"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlowTypeRag);
export default __webpack_public_path__ + "static/media/flowTypeRAG.96e69d61707e1948d435a1fca9fd6639.svg";
export { ForwardRef as ReactComponent };